<template>
  <v-dialog max-width="600px" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">Product Group</span>
        <v-spacer/>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text>
        <v-row dense class="mb-3">
          <v-col cols="12" md="4" sm="4">
            <r-product-group-kind :model.sync="model.kind" label="Kind" :multiple="false" :disabled="true"/>
          </v-col>
          <v-col cols="12" md="3" sm="3">
            <v-text-field label="Order" v-model.number="model.order"/>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-text-field v-model.number="model.resetTime" label="Reset time" hide-details/>
          </v-col>
            <v-col cols="12" sm="3" md="3">
                <v-checkbox
                        v-model.number="model.oneRow"
                        label="In One Row"
                        :true-value="1"
                        :false-value="0"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-row dense>
          <v-expansion-panels>
            <r-currency-panel :items.sync="model.resetPrice" title="Reset Price"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {ProductGroup} from "@/modules/redactor/models/product/ProductGroup";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

import RAuthorize from "@/modules/redactor/views/common/r-authorize.vue";
import RCurrencyPanel from "@/modules/redactor/views/currency/r-currency-panel.vue";
import RProductGroupKind from "@/modules/redactor/views/product-group/r-product-group-kind.vue";

export default {
  name: "r-product-group-dialog",
  components: {RProductGroupKind, RAuthorize, RCurrencyPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ProductGroup(),
    rules: ViewRules.READONLY,
  }),
  computed: {
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ProductGroup();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    }
  }
};
</script>

<style lang="css" scoped>
:read-only {
  white-space: nowrap;
}
</style>